import React, {Component} from 'react'
import {CampaignPreviewCard, Campaign} from 'dabbl-react-components'
import iPhoneImage from '../../shared/assets/white-iphone.png';
import GooglePixelImage from '../../shared/assets/white-googlepixel.png';

// Components

class PhonePreviewIFrame extends Component {

  constructor(props) {
    super(props)
  }

  getScreenPosition() {
    const { phonePlatform } = this.props;

    switch (phonePlatform) {
      case 'iphone':
        return {
          overflow: "hidden",
          position: "absolute",
          top: "12%",
          bottom: "12%",
          left: "6%",
          right: "6%",
        };

      case 'android':
      default:
        return {
          overflow: "hidden",
          position: "absolute",
          top: "12%",
          bottom: "13.5%",
          left: "6%",
          right: "6%",
        };
    }
  }

  getPreviewFrame(){
    console.log(window)
    const phonePreviewUri = `${window.location.protocol}//${window.location.hostname+(window.location.port ? ':'+window.location.port: '')}/previewinternal/${this.props.previewToken}${this.props.location.search}`

    return (
      <iframe
        style={{
          height: '100%',
          width:'100%',
          maxWidth: '991px',
          border: 'none'
        }}
        src={phonePreviewUri}
        sandbox="allow-same-origin allow-scripts allow-top-navigation allow-popups"
        ref={(framePreview) => { this.framePreview = framePreview; }}
      >
      </iframe>
    )
  }

  render() {

    if(/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)){
      return (this.getPreviewFrame())
    }

    let phonePlatform = 'generic';
    let align = 'center'
    let width = 300

    if(phonePlatform === 'generic'){
      return (
          <div
            className="PhonePreviewIFrame"
            style={{
              height:550,
              overflow: "hidden",
              transformOrigin:`top ${align}`,
              borderRadius:'2rem',
              border:'1px solid #C5C5C5',
              backgroundColor:'white',
              boxShadow:'0 24px 24px rgba(0,0,0,0.1)'
            }}
          >
            {/* Phone Picture */}
            <div
              className="PhonePreview_screen"
              style={{
                backgroundColor:'#FFF',
                overflow: "hidden",
                position: "absolute",
                border: '1px solid #C5C5C5',
                top:33,
                bottom:33,
                left:14,
                right:14
              }}
            >
              {this.getPreviewFrame()}
            </div>
          </div>

      )
    }


    return (
      <div
        className="PhonePreviewIFrame"
        style={{
          height:(width * 2) + 20,
          overflow: "hidden"
        }}
      >
        {/* Phone Picture */}
        <div
          style={{
            overflow: "hidden",
            transform:`scale(${width/300})`,
            transformOrigin:'top left'
          }}
        >
          <img
            className="PhonePreview_img"
            src={(phonePlatform === 'android') ? GooglePixelImage : iPhoneImage}
            alt="Preview of activities on cell phones"
          />
          {/* Screen Container - use position: absolute for all children */}
          <div
            className="PhonePreview_screen"
            style={this.getScreenPosition()}
          >
            {this.getPreviewFrame()}
          </div>
        </div>
      </div>
    );
  }
}

export default PhonePreviewIFrame





// WEBPACK FOOTER //
// ./src/routes/PhonePreviewIFrame/PhonePreviewIFrame.js